import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import { ref } from "@vue/composition-api";
import ConnectedAccountViewModel from "../models/ConnectedAccountViewModel";
export default function () {
    const connectedAccount = ref<Array<ConnectedAccountViewModel>>([]);

    const get = async () => {
        await defineHeaderAxios();
        Axios.get("/api/connectedAccount")
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    connectedAccount.value = result.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const approve = async (id: string): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(`/api/connectedAccount/approve/${id}`, id)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const allowGallery = async (id: string): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(`/api/connectedAccount/allowGallery/${id}`, id)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const denyGallery = async (id: string): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(`/api/connectedAccount/denyGallery/${id}`, id)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const allowUpload = async (id: string): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(`/api/connectedAccount/allowUpload/${id}`, id)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const denyUpload = async (id: string): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(`/api/connectedAccount/denyUpload/${id}`, id)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const lockout = async (id: string): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(`/api/connectedAccount/lockout/${id}`, id)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const remove = async (id: string): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.delete(`/api/connectedAccount/remove/${id}`)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    get();
    return {
        connectedAccount,
        remove,
        get,
        approve,
        lockout,
        allowGallery,
        denyGallery,
        allowUpload,
        denyUpload
    };
}
